import AxiosService from "../AxiosService";
import {webSocketService} from "@/services/question";

let surveyDetails = "";

let timeoutId = 0;

export default class QuestionCookieService {
  constructor() {
    this.axiosService = new AxiosService();
  }

  // set server cookie to be used with websocket
  resolveCookie(payload) {
    surveyDetails = payload;
    clearTimeout(timeoutId);

    return this.axiosService.post(`/api/resolve-cookie`, payload, null)
      .then(result => {
        let response = result.data;
        webSocketService.reconnectWebsocket();
        if (response) {
          timeoutId = setTimeout(() => {
            this.resolveCookie(payload)
          }, response.trigger);
        }
      })
  }

  getActiveSurvey() {
    return surveyDetails;
  }
}
